import React from "react";

import { useBanner } from "../../../hooks/useBanner";
// import { heroSlides } from '../../../constants/heroSlides';
// import { Slide } from '../../../types';

// Slideshow code commented out - replaced with video
// const AUTO_ROTATE_INTERVAL = 5000; // 5 seconds

const isVideo = (url?: string) => {
  if (!url) return false;
  const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv'];
  return videoExtensions.some(ext => url.toLowerCase().endsWith(ext)) || url.includes('video');
};

const Hero: React.FC = () => {
  const { banner } = useBanner();
  // const [currentSlide, setCurrentSlide] = useState(0);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  //   }, AUTO_ROTATE_INTERVAL);

  //   return () => clearInterval(interval);
  // }, []);

  // const goToSlide = (index: number) => {
  //   setCurrentSlide(index);
  // };

  return (
    <section
      id="section-hero"
      className="no-top no-bottom relative m-0"
      style={{ padding: 0 }}
    >
      <style>
        {`
          @keyframes scaleInFade {
            from {
              opacity: 0;
              transform: scale(1.1) translate3d(0, -40px, 0);
            }
            to {
              opacity: 1;
              transform: scale(1) translate3d(0, 0, 0);
            }
          }
          .animate-item {
            opacity: 0;
            animation: scaleInFade 2s ease-out both;
          }
          .hero-delay-1 { animation-delay: 0.2s; }
          .hero-delay-2 { animation-delay: 1s; }
          .hero-delay-3 { animation-delay: 2s; }
          .hero-delay-4 { animation-delay: 2s; }
          
          @keyframes fadeInOnly {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          .animate-fade-only {
            opacity: 0;
            animation: fadeInOnly 4s ease-in both;
          }
          
          @keyframes fadeVideoIn {
            from { opacity: 0; }
            to { opacity: 0.4; }
          }
          
          .video-fade-in {
            animation: fadeVideoIn 1.5s ease-out forwards;
          }
        `}
      </style>
      <div
        className="hero-video-container"
        style={{
          position: "relative",
          width: "100%",
          height: "100vh",
          overflow: "hidden",
          backgroundColor: "white",
          backgroundImage: banner?.image && !isVideo(banner.image) ? `url(${banner.image})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {banner?.image && isVideo(banner.image) ? (
          <video
            className="hero-video video-fade-in"
            src={banner.image}
            autoPlay
            loop
            muted
            playsInline
          />
        ) : null}
        {/* Content Overlay */}
        <div
          className="hero-slide-content"
          style={{
            position: "relative",
            zIndex: 2,
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center">
                {/* Subtitle in brackets */}
                <p
                  className="hero-subtitle animate-item hero-delay-1"
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: 600,
                    color: "white",
                    marginBottom: "1rem",
                    letterSpacing: "2px",
                    textTransform: "uppercase",
                  }}
                >
                  [{banner?.title}]
                </p>

                {/* Logo */}
                <img
                  className="animate-item hero-delay-2"
                  src="/images/hkust/AI literacy hub logo_tag_transparent.png"
                  alt="AI Literacy Hub Logo"
                  style={{ maxWidth: "80%", maxHeight: "150px" }}
                />

                {/* Main Title */}
                <h1 className="hero-title animate-item hero-delay-3">
                  {banner?.caption}
                </h1>

                {/* Buttons */}
                <div
                  className="hero-buttons animate-fade-only hero-delay-4"
                  style={{ marginTop: "2.5rem" }}
                >
                  <a
                    className="btn-main hero-btn-primary mx-2"
                    href={banner?.button_url_1}
                  >
                    <span>{banner?.button_text_1}</span>
                  </a>
                  <a
                    className="btn-main btn-line hero-btn-secondary mx-2"
                    href={banner?.button_url_2}
                  >
                    <span>{banner?.button_text_2}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Commented out slideshow code */}
      {/* <div className="hero-carousel-container">
        <div className="hero-carousel" id="heroCarousel">
          {heroSlides.map((slide: Slide, index: number) => (
            <div
              key={index}
              className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            >
              <picture>
                <source media="(max-width: 768px)" srcSet={slide.image} />
                <img src={slide.image} alt={slide.title} className="hero-slide-img" />
              </picture>
              <div className="hero-slide-content">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <h1 className="hero-title">{slide.title}</h1>
                      <p className="hero-description">{slide.description}</p>
                      <div className="spacer-single"></div>
                      <a className="btn-main mx-2" href={slide.button1.link}>
                        <span>{slide.button1.text}</span>
                      </a>
                      {slide.button2 && (
                        <a className="btn-main btn-line mx-2" href={slide.button2.link}>
                          <span>{slide.button2.text}</span>
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="hero-carousel-dots">
          {heroSlides.map((_: Slide, index: number) => (
            <span
              key={index}
              className={`hero-dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            ></span>
          ))}
        </div>
      </div> */}
    </section>
  );
};

export default Hero;
